<template>
    <div class="HeaderSearch" :class="{noFixed:!ifFixed}">
        <!--头部信息-->
    <LayoutHeader :ifFixed="ifFixed" :fixedHeight="fixedHeight" :showInput="ifFixed" />
    <img class="title" src="@/assets/img/home/header-title.png" alt="" srcset="">

    <div class="title-dec">
        <div class="dec-item">
            <img src="@/assets/img/home/header-top.png" alt="" srcset="">
            <span><span class="blod">1000+</span> 本月新增模板</span>
        </div>
        <div  class="dec-item">
            <img src="@/assets/img/home/header-hou.png" alt="" srcset="">
            <span><span class="blod">5W+</span> 已收录方案</span>
        </div>
    </div>
    <SearchHeaderInput @search="onSearch" class="SearchHeaderInput" />
    <SearchHot @search="onSearch" />
    </div>
</template>

<script>
import LayoutHeader from "@/components/LayoutHeader";
import SearchHot from "@/components/common/SearchHot";
import SearchHeaderInput from "@/components/common/SearchHeaderInput";

export default {
    name: 'HeaderSearch' ,
    components: { 
        LayoutHeader ,
        SearchHot,
        SearchHeaderInput
    },
    data() {
        return {
            ifFixed:false,
            fixedHeight:316
        };
    },
    methods: {
        handleScroll(e) {
        const element = document.getElementById('pageScroll');
        // 距顶部
        this.ifFixed =e.target.scrollTop>this.fixedHeight;
        console.log(this.ifFixed);
        
        },
        onSearch(item){
            window.open(`/search?keyword=${item}`);

        }
    },
    mounted() {
    // window.addEventListener("scroll", this.handleScroll);
      const element = document.getElementById('pageScroll');
      element.addEventListener('scroll', this.handleScroll);
   
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.handleScroll);
    const element = document.getElementById('pageScroll');
    element.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.HeaderSearch{
    height: 314px;
    background: url('@/assets/img/home/header-bg.png') no-repeat;
    background-size:100% 100% ;
    display: flex;
    flex-direction: column;
    align-items: center;
   
    &.noFixed{
        .LayoutHeader{
        background: none;
        align-items: center;
    }
    }
    .title{
        width: 1009px;
        margin-top: 16px;
    }
    .title-dec{
        display: flex;
        color:#fff;
        margin-top: 20px;
        .dec-item{
            display: flex;
            align-items: center;
            margin-right: 24px;
        }
        img{
            width:20px;
            margin-right: 8px;
            
        }
        .blod{
            font-weight: 550;
        }

    }
    .SearchHeaderInput{
        margin: 24px 0 16px;
        width: 880px;

        ::v-deep  .el-input .el-input__inner{
           height:56px;
           padding-left:24px;
        }
        ::v-deep .HeaderInputButton{
            height: 56px;
        }
    }
    .search-hot{
        margin-top: 8px;
        ::v-deep span{
            padding: 0 16px;
        }
    }
}

</style>
